import { render, staticRenderFns } from "./ChangePhoneModal.vue?vue&type=template&id=d303eda2&scoped=true&"
import script from "./ChangePhoneModal.vue?vue&type=script&lang=js&"
export * from "./ChangePhoneModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d303eda2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d303eda2')) {
      api.createRecord('d303eda2', component.options)
    } else {
      api.reload('d303eda2', component.options)
    }
    module.hot.accept("./ChangePhoneModal.vue?vue&type=template&id=d303eda2&scoped=true&", function () {
      api.rerender('d303eda2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MyProfileMobile/ChangePhoneModal.vue"
export default component.exports